import { useState } from "react";

export const IN_FLIGHT_POLL_MS = 15_000;

/**
 * `pollingInterval` for a run list or detail query that should refresh while
 * some row is still executing.
 *
 * A state cell, as in BrowserWarmingDialog: a query hook's options cannot
 * read the hook's own result in the same render, so the caller reports
 * `setActive(rows.some(isRunExecuting))` (`isClientRunExecuting` for client
 * rows, see `clientRunStatus.ts`) from an effect after the result arrives,
 * and the interval follows on the next render.
 */
export function useInFlightPolling(): [number, (active: boolean) => void] {
  const [active, setActive] = useState(false);
  return [active ? IN_FLIGHT_POLL_MS : 0, setActive];
}
